class PdpVideoList extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.currentVideo = null;
    this.fullscreenOverlay = null;
  }

  connectedCallback() {
    this.initSwiper();
    this.initVideoControls();
    this.createFullscreenOverlay();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
    this.pauseAll();
    this.removeFullscreenOverlay();
  }

  initSwiper() {
    var container = this.querySelector('.swiper-container');
    if (!container) return;

    this.swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
    });
  }

  initVideoControls() {
    var buttons = this.querySelectorAll('.pdp-video-list__play-btn');
    var self = this;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pdp-video-list__item');
        var video = item.querySelector('.pdp-video-list__video');
        if (!video) return;

        if (item.classList.contains('pdp-video-list__item--playing')) {
          self.pauseVideo(item, video);
        } else {
          self.pauseAll();
          self.playVideo(item, video);
        }
      });
    });

    // Fullscreen buttons
    var fsBtns = this.querySelectorAll('.pdp-video-list__fullscreen-btn');
    fsBtns.forEach(function (fsBtn) {
      fsBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var item = fsBtn.closest('.pdp-video-list__item');
        var video = item.querySelector('.pdp-video-list__video');
        var poster = item.querySelector('.pdp-video-list__poster');
        if (video) {
          self.openFullscreen(video, poster);
        }
      });
    });
  }

  playVideo(item, video) {
    video.style.display = 'block';
    video.play();
    item.classList.add('pdp-video-list__item--playing');
    this.currentVideo = { item: item, video: video };
  }

  pauseVideo(item, video) {
    video.pause();
    video.style.display = 'none';
    item.classList.remove('pdp-video-list__item--playing');
    if (this.currentVideo && this.currentVideo.video === video) {
      this.currentVideo = null;
    }
  }

  pauseAll() {
    var items = this.querySelectorAll('.pdp-video-list__item--playing');
    var self = this;
    items.forEach(function (item) {
      var video = item.querySelector('.pdp-video-list__video');
      if (video) {
        self.pauseVideo(item, video);
      }
    });
  }

  createFullscreenOverlay() {
    if (this.fullscreenOverlay) return;

    var overlay = document.createElement('div');
    overlay.className = 'pdp-video-fullscreen';
    overlay.innerHTML =
      '<div class="pdp-video-fullscreen__backdrop"></div>' +
      '<div class="pdp-video-fullscreen__container">' +
        '<img class="pdp-video-fullscreen__poster" src="" alt="" />' +
        '<video class="pdp-video-fullscreen__video" playsinline loop preload="none"></video>' +
        '<div class="pdp-video-fullscreen__loader">' +
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="20" cy="20" r="17" stroke="rgba(255,255,255,0.3)" stroke-width="3"/>' +
            '<path d="M37 20a17 17 0 0 0-17-17" stroke="white" stroke-width="3" stroke-linecap="round"/>' +
          '</svg>' +
        '</div>' +
        '<div class="pdp-video-fullscreen__overlay"></div>' +
        '<div class="pdp-video-fullscreen__controls">' +
          '<button class="pdp-video-fullscreen__close-btn" aria-label="Close fullscreen">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M18 6L6 18M6 6l12 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
          '<button class="pdp-video-fullscreen__mute-btn" aria-label="Unmute" data-muted="true">' +
            '<svg class="pdp-video-fullscreen__icon-muted" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M11 5L6 9H2v6h4l5 4V5Z" fill="white"/>' +
              '<line x1="23" y1="9" x2="17" y2="15" stroke="white" stroke-width="2" stroke-linecap="round"/>' +
              '<line x1="17" y1="9" x2="23" y2="15" stroke="white" stroke-width="2" stroke-linecap="round"/>' +
            '</svg>' +
            '<svg class="pdp-video-fullscreen__icon-unmuted" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M11 5L6 9H2v6h4l5 4V5Z" fill="white"/>' +
              '<path d="M15.54 8.46a5 5 0 0 1 0 7.07" stroke="white" stroke-width="2" stroke-linecap="round"/>' +
              '<path d="M19.07 4.93a10 10 0 0 1 0 14.14" stroke="white" stroke-width="2" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    this.fullscreenOverlay = overlay;

    var self = this;

    // Close button
    overlay.querySelector('.pdp-video-fullscreen__close-btn').addEventListener('click', function () {
      self.closeFullscreen();
    });

    // Backdrop click to close
    overlay.querySelector('.pdp-video-fullscreen__backdrop').addEventListener('click', function () {
      self.closeFullscreen();
    });

    // Mute/unmute toggle
    var muteBtn = overlay.querySelector('.pdp-video-fullscreen__mute-btn');
    muteBtn.addEventListener('click', function () {
      var fsVideo = overlay.querySelector('.pdp-video-fullscreen__video');
      if (fsVideo.muted) {
        fsVideo.muted = false;
        muteBtn.setAttribute('data-muted', 'false');
        muteBtn.setAttribute('aria-label', 'Mute');
      } else {
        fsVideo.muted = true;
        muteBtn.setAttribute('data-muted', 'true');
        muteBtn.setAttribute('aria-label', 'Unmute');
      }
    });

    // Escape key to close
    this._escHandler = function (e) {
      if (e.key === 'Escape' && self.fullscreenOverlay.classList.contains('is-active')) {
        self.closeFullscreen();
      }
    };
    document.addEventListener('keydown', this._escHandler);
  }

  removeFullscreenOverlay() {
    if (this.fullscreenOverlay) {
      this.fullscreenOverlay.remove();
      this.fullscreenOverlay = null;
    }
    if (this._escHandler) {
      document.removeEventListener('keydown', this._escHandler);
      this._escHandler = null;
    }
  }

  openFullscreen(sourceVideo, posterImg) {
    if (!this.fullscreenOverlay || !sourceVideo) return;

    var overlay = this.fullscreenOverlay;
    var fsVideo = overlay.querySelector('.pdp-video-fullscreen__video');
    var fsPoster = overlay.querySelector('.pdp-video-fullscreen__poster');
    var loader = overlay.querySelector('.pdp-video-fullscreen__loader');

    // Show poster as immediate background while video loads
    if (posterImg && posterImg.src) {
      fsPoster.src = posterImg.src;
      fsPoster.style.display = 'block';
    } else {
      fsPoster.style.display = 'none';
    }

    // Show loader
    loader.style.display = 'flex';

    // Copy sources from the inline video
    fsVideo.innerHTML = sourceVideo.innerHTML;
    fsVideo.muted = true;
    fsVideo.load();

    // Reset mute button state
    var muteBtn = overlay.querySelector('.pdp-video-fullscreen__mute-btn');
    muteBtn.setAttribute('data-muted', 'true');
    muteBtn.setAttribute('aria-label', 'Unmute');

    // Show overlay
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // When video is ready to play, hide poster and loader
    var onCanPlay = function () {
      fsVideo.removeEventListener('canplay', onCanPlay);
      fsPoster.style.display = 'none';
      loader.style.display = 'none';
      fsVideo.play();
    };
    fsVideo.addEventListener('canplay', onCanPlay);

    // Fallback: if canplay doesn't fire within 5s, try playing anyway
    this._loadTimeout = setTimeout(function () {
      fsVideo.removeEventListener('canplay', onCanPlay);
      fsPoster.style.display = 'none';
      loader.style.display = 'none';
      fsVideo.play();
    }, 5000);

    this._fullscreenSourceVideo = sourceVideo;
  }

  closeFullscreen() {
    if (!this.fullscreenOverlay) return;

    if (this._loadTimeout) {
      clearTimeout(this._loadTimeout);
      this._loadTimeout = null;
    }

    var overlay = this.fullscreenOverlay;
    var fsVideo = overlay.querySelector('.pdp-video-fullscreen__video');

    fsVideo.pause();
    fsVideo.muted = true;
    fsVideo.removeAttribute('src');
    fsVideo.innerHTML = '';

    overlay.querySelector('.pdp-video-fullscreen__poster').style.display = 'none';
    overlay.querySelector('.pdp-video-fullscreen__loader').style.display = 'none';

    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    this._fullscreenSourceVideo = null;
  }
}

customElements.define('pdp-video-list', PdpVideoList);
